import { FC } from 'react'
import Layout from 'components/layout/Layout'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { fetchFaqQuestionsAndSections } from 'api/faq'
import { MiniGeneratorsProps as Props } from 'features/mini-generators/types'
import MiniGenerators from 'features/mini-generators/MiniGenerators'

const MiniGeneratorsPage: FC<Props> = (props) => {
  return (
    <Layout>
      <MiniGenerators {...props} />
    </Layout>
  )
}

export const getStaticProps = async ({ locale }) => {
  const { sections, questions } = await fetchFaqQuestionsAndSections(locale)

  return {
    props: {
      sections,
      questions,
      ...(await serverSideTranslations(locale))
    },
    revalidate: 600 // re-generate page when a request comes in, once every 10 minutes
  }
}

export default MiniGeneratorsPage
